<script lang="ts" setup>
	import type { RuleObject } from 'ant-design-vue/es/form'
	import type { FormItemProps, InputProps } from 'ant-design-vue'

	const { input: inputProp, ...props } = defineProps<FormItemProps & { input?: InputProps }>()

	const modelValue = defineModel<string>()
	const emit = defineEmits<{
		(arg: 'change', value: string): void
	}>()
	const validatePhoneFormat = (_: RuleObject, value: string) => {
		const defErr = (msg: string) => {
			return Promise.reject(new Error(msg))
		}

		if (!value) {
			return defErr('Please enter a valid phone number')
		} else if (String(value).startsWith('0') && String(value).length < 11) {
			return defErr('Phone number must not be less than 11 characters')
		} else if (String(value).startsWith('234') && String(value).length < 13) {
			return defErr('Phone number must not be less than 13 characters')
		} else if (String(value).length > 11 && String(value).length < 13) {
			return defErr('Phone number must not be less than 13 characters')
		}
		return Promise.resolve()
	}
	const change = (e: unknown) => {
		const v = e?.target?.value || ''
		emit('change', v)
	}
</script>

<template>
	<div>
		<a-form-item
			v-bind="props"
			:colon="false"
			auto-link
			validate-trigger="change"
			:rules="{
				validator: validatePhoneFormat,
				...(props?.rules ?? {})
			}"
		>
			<a-input
				v-model:value="modelValue"
				v-tel="true"
				type="tel"
				:data-testid="props.name"
				inputmode="tel"
				class="custom-input !bg-gray-50 !px-5"
				v-bind="inputProp"
				@change="change"
			/>
		</a-form-item>
	</div>
</template>
